/**
 * Supabase Client
 * 
 * Initializes and exports the Supabase client singleton for use throughout the application.
 * This client is configured with automatic token refresh and session persistence.
 */

import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please ensure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set in .env.local'
  );
}

/**
 * Supabase client instance
 * 
 * Configured with:
 * - autoRefreshToken: true - Automatically refreshes expired tokens
 * - persistSession: true - Persists session across page reloads
 * - detectSessionInUrl: true - Detects magic link authentication from URL
 */
export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});


